import { useEffect } from 'react';

import { useProductBySlugBasicPDP } from '@/modules/product/hooks/useProductBySlugBasicPDP';
import { useProductBySlugExtendedPDP } from '@/modules/product/hooks/useProductBySlugExtendedPDP';
import {
  addProductToLocalStorage as addRecentlyViewedProductToLocalStorage,
  createLocallyStoredRecentlyViewedProduct,
} from '@/modules/recentlyViewed/helpers';
import { useCurrentUser } from '@/modules/user/useCurrentUser';

export function useAddRecentlyViewedToLocalStorage() {
  const [isAuthenticated] = useCurrentUser();
  const { data: product } = useProductBySlugBasicPDP();
  const { data: productExtended } = useProductBySlugExtendedPDP();

  useEffect(() => {
    if (product && productExtended) {
      if (!isAuthenticated) {
        addRecentlyViewedProductToLocalStorage(
          createLocallyStoredRecentlyViewedProduct(product, productExtended)
        );
      }
    }
  }, [product, productExtended, isAuthenticated]);
}
